/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_TechnicalInputs */

const en_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Issue`)
};

const fr_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probleme technique`)
};

const de_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technisches Problem`)
};

const it_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema tecnico`)
};

const ru_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Техническая проблема`)
};

const es_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema técnico`)
};

const zh_cn2_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术问题`)
};

const ja_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術的な問題`)
};

const hi_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तकनीकी समस्या`)
};

const pt_pt2_manual_qc_type_technical = /** @type {(inputs: Manual_Qc_Type_TechnicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema técnico`)
};

/**
* | output |
* | --- |
* | "Technical Issue" |
*
* @param {Manual_Qc_Type_TechnicalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_technical = /** @type {((inputs?: Manual_Qc_Type_TechnicalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_TechnicalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_technical(inputs)
	if (locale === "de") return de_manual_qc_type_technical(inputs)
	if (locale === "it") return it_manual_qc_type_technical(inputs)
	if (locale === "ru") return ru_manual_qc_type_technical(inputs)
	if (locale === "es") return es_manual_qc_type_technical(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_technical(inputs)
	if (locale === "ja") return ja_manual_qc_type_technical(inputs)
	if (locale === "hi") return hi_manual_qc_type_technical(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_technical(inputs)
	return en_manual_qc_type_technical(inputs)
});